import script from "./VVVClaimSubmissionTable.vue?vue&type=script&setup=true&lang=js"
export * from "./VVVClaimSubmissionTable.vue?vue&type=script&setup=true&lang=js"

import "./VVVClaimSubmissionTable.vue?vue&type=style&index=0&id=316e444e&scoped=true&lang=css"
import "./VVVClaimSubmissionTable.vue?vue&type=style&index=1&id=316e444e&lang=css"

import exportComponent from "D:\\a\\1\\s\\CSD.SPA\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-316e444e"]])

export default __exports__